import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import AuthPage from './pages/AuthPage';
import DoctorSignUp from './pages/DoctorSignUp';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PatientSignUp from './pages/PatientSignUp';
import PatientView from './pages/PatientView'; 
import PatientUpdate from './pages/PatientUpdate'; 
import PatientList from './pages/PatientList';
import SideNav from './components/SideNav';
import Home from './pages/Home';
import PatientHistory from './pages/PatientHistory';
import ViewPatientHistory from './pages/ViewPatientHistory';
import CreatePatientHistory from './pages/CreatePatientHistory';
import CustomAppBar from './components/AppBar';
import { Toolbar, Box } from '@mui/material';
import Drugs from './pages/Drugs';
import ProtectedRoute from './components/ProtectedRoute';
import PrintTestComponent from './pages/print';
import RecipePage from './pages/RecipePage';
import DiagnosticosTratamientos from './pages/DiagnosticosTratamientos';
import HistoriasDeHoy from './pages/HistoriasDeHoy';
import ContabilidadMedico from './pages/ContabilidadMedico';
import ContabilidadSecretaria from './pages/ContabilidadSecretaria';
import AgendaDiaria from './pages/AgendaDiaria';
import ContabilidadMensual from './pages/ContabilidadMensual';
import AgendaMedica from './pages/AgendaMedica';
import AgendaProcedimientos from './pages/AgendaProcedimientos';

const AppContent = () => {
    const location = useLocation();

    const hideSideNavPaths = ['/login', '/doctor-signup', '/forgot-password', '/', '/reset-password/:token','landing/index.html'];

    const shouldHideSideNav = hideSideNavPaths.includes(location.pathname);

    return (
        <div style={{ display: 'flex' }}>
            {!shouldHideSideNav && <SideNav />}
            <Box sx={{ flexGrow: 1, padding: 2, marginLeft: { sm: shouldHideSideNav ? 0 : '50px' } }}>
                {!shouldHideSideNav && <CustomAppBar />}
                <Toolbar />
                <Routes>
                    <Route path="/login" element={<AuthPage />} />
                    <Route path="/" element={<Navigate to="/login" replace />} />
                    <Route path="/doctor-signup" element={<DoctorSignUp />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/home" element={<ProtectedRoute component={Home} />} />
                    <Route path="/register-patient" element={<ProtectedRoute component={PatientSignUp} />} />
                    <Route path="/view-patient/:idNumber" element={<ProtectedRoute component={PatientView} />} />
                    <Route path="/update-patient/:idNumber" element={<ProtectedRoute component={PatientUpdate} />} />
                    <Route path="/view-patients" element={<ProtectedRoute component={PatientList} />} />
                    <Route path="/historias/:idPac" element={<PatientHistory />} />
                    <Route path="/view-patient-history/:id" element={<ProtectedRoute component={ViewPatientHistory} />} />
                    <Route path="/create-patient-history/:id" element={<ProtectedRoute component={CreatePatientHistory} />} />
                    <Route path="/drugs" element={<ProtectedRoute component={Drugs} />} />
                    <Route path="/print" element={<ProtectedRoute component={PrintTestComponent} />} />
                    <Route path="/recipe/:idHistoria" element={<ProtectedRoute component={RecipePage} />} />
                    <Route path="/diagnosticos-tratamientos" element={<DiagnosticosTratamientos />} />
                    <Route path="/historias-hoy" element={<HistoriasDeHoy />} />
                    <Route path="/contabilidad-medico" element={<ProtectedRoute component={ContabilidadMedico} />} />
                    <Route path="/contabilidad-secretaria" element={<ProtectedRoute component={ContabilidadSecretaria} />} />
                    <Route path="/agenda-diaria" element={<ProtectedRoute component={AgendaDiaria} />} />
                    <Route path="/contabilidad-mensual" element={<ProtectedRoute component={ContabilidadMensual} />} />
                    <Route path="/agenda-medica" element={<AgendaMedica component={AgendaMedica}/>} />
                    <Route path="/agenda-procedimientos" element={<ProtectedRoute component={AgendaProcedimientos} />} />
                </Routes>
            </Box>
        </div>
    );
};

const App = () => {
    return (
        <Router>
            <AppContent />
        </Router>
    );
};



export default App;
